export const ORDER_TRACKING_PATH = '/order-tracking';
export const ORDER_TRACKING_ID_PARAM = 'id';
export const ORDER_TRACKING_SHARE_COPIED_RESET_DELAY = 2000;
